const minimalSpacingsArrayLength = 2;

interface DividerProps {
  size?: 'thin' | 'wide';
  /** Single number -- both top and bottom margins, array -- [top, bottom] */
  spacing?: number | number[];
}

const Divider = ({ size = 'thin', spacing = 16 }: DividerProps) => (
  <hr
    style={{
      borderColor: 'rgba(33, 34, 49, 0.16)',
      margin:
        Array.isArray(spacing) && spacing.length >= minimalSpacingsArrayLength
          ? `${spacing[0]}px 0 ${spacing[1]}px`
          : `${spacing}px 0`,
      borderWidth: `1px 0 ${size === 'wide' ? '1px' : 0}`,
    }}
  />
);

export default Divider;
